import * as Sentry from '@sentry/browser';

export function getSentry() {
	return Sentry;
}
